import { chargePointHttpClient } from "../../installations/axiosInterfaces";
import alertService from "../alert/alert.service";

const getChargePointBySerialNumber = (serialNumber, conenctorNumber) => {
  return chargePointHttpClient.get(`Get/SerialNumber/${serialNumber}${conenctorNumber ? `/${conenctorNumber}` : ""}`);
};

const getChargePointDetails = (chargePointId) => {
  return chargePointHttpClient.get(`Get/ChargePointDetails/${chargePointId}`);
};

const getChargePointDetailsByExternalIdentifiers = (partyId, uid, connectorNumber) => {
  return chargePointHttpClient.get(`Get/External/${partyId}/${uid}/${connectorNumber}`);
};

const startChargingTransaction = (clientId, chargePointId, paymentTokenId) => {
  // Validate paymentTokenId before building URL
  if (!paymentTokenId || paymentTokenId === 'null' || paymentTokenId === 'undefined') {
    return Promise.reject(new Error('Payment token ID is required'));
  }
  
  // Validate clientId before building URL
  if (!clientId || clientId === 'null' || clientId === 'undefined') {
    return Promise.reject(new Error('Client ID is required'));
  }
  
  return chargePointHttpClient.get(`ChargingTransaction/Start/${clientId}/${chargePointId}/${paymentTokenId}`);
};

const stopChargingTransaction = (token) => {
  return chargePointHttpClient.get(`ChargingTransaction/Stop/${token}`);
};

const getOpenChargingTransactionToken = (chargePointId, identificationValue, last4Digit) => {
  return chargePointHttpClient.get(`ChargingTransaction/TransactionToken/ClientAuthentication/${chargePointId}/${identificationValue}/${last4Digit}`);
};

const getChargingTransactionDetailsByToken = (token) => {
  return chargePointHttpClient.get(`ChargingTransaction/TransactionDetails/${token}`);
};

const chargePointService = {
  getChargePointBySerialNumber,
  getChargePointDetails,
  getChargePointDetailsByExternalIdentifiers,
  startChargingTransaction,
  stopChargingTransaction,
  getOpenChargingTransactionToken,
  getChargingTransactionDetailsByToken,
};

export default chargePointService;
